module.exports = __webpack_public_path__ + "static/media/kkk.eea26d7f.png";